import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { getQueryParams } from '@hglobal/common';
import { map, Observable } from 'rxjs';

import { GetPaginationRes, PaginationReq, Skin } from '@pp/core/entities';
import { withManualOrgId } from '@pp/core/helpers';
import { environment } from '@pp/environment';

import { NotificationsApiInterface } from './notifications.api.interface';
import {
  GetNotificationHistoryParams,
  mapNotification,
  Notification,
  NotificationApiEntity,
  NOTIFICATIONS_DEFAULT_LIMIT,
  NOTIFICATIONS_DEFAULT_PAGE,
  NotificationsCount,
  NotificationsHistoryResponse,
  NotificationType,
} from './notifications.entities';

const API_NOTIFICATIONS = 'notifications/';

@Injectable()
export class NotificationsApi implements NotificationsApiInterface {
  readonly #http = inject(HttpClient);

  getUnreadCount(): Observable<NotificationsCount> {
    const api = environment.apiHost + API_NOTIFICATIONS + 'unread_count/';

    return this.#http.get<NotificationsCount>(api, { headers: withManualOrgId() });
  }
  getNotificationsHistory(
    pagination: PaginationReq,
    typesArr: NotificationType[],
    skins?: Skin[],
  ): Observable<GetPaginationRes<Notification>> {
    const api = environment.apiHost + API_NOTIFICATIONS;
    pagination = pagination || { page: NOTIFICATIONS_DEFAULT_PAGE, limit: NOTIFICATIONS_DEFAULT_LIMIT };

    const isThreeDs = typesArr.includes(NotificationType.THREE_DS_NOTIFICATION);
    const types = typesArr.join(',');
    const params = {
      ...pagination,
      types,
    };

    return this.#http
      .get<{
        notifications: NotificationApiEntity[];
        itemsCount: number;
      }>(api, { params: getQueryParams(params), headers: withManualOrgId() })
      .pipe(
        map(({ notifications, itemsCount }) => ({
          itemsCount,
          items: notifications.map(notification => mapNotification(notification, skins, isThreeDs)),
        })),
      );
  }

  getNotificationsHistoryNew(params: GetNotificationHistoryParams): Observable<NotificationsHistoryResponse> {
    const api = environment.apiHost + API_NOTIFICATIONS;

    return this.#http.get<NotificationsHistoryResponse>(api, { params: getQueryParams(params), headers: withManualOrgId() });
  }

  readMessage(notification: Notification): Observable<void> {
    const api = environment.apiHost + API_NOTIFICATIONS + `${notification.id}/mark_as_read/`;

    return this.#http.post<void>(api, null);
  }

  readAll(): Observable<void> {
    const api = environment.apiHost + API_NOTIFICATIONS + `mark_all_as_read/`;

    return this.#http.post<void>(api, null, { headers: withManualOrgId() });
  }

  setNotificationsSettings(params: { disable: boolean }) {
    const api = environment.apiHost + API_NOTIFICATIONS + `settings/`;

    return this.#http.patch<void>(api, {}, { headers: withManualOrgId(), params: getQueryParams(params) });
  }
}
